/**
 * @generated SignedSource<<43d819fe0ca766d9f336cce7869f4550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserMarkerTooltipContent_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UserGroups_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

node.hash = "18d237fddd81b0c3ac2d7f05b08fb5da";

module.exports = node;
